<template>
  <section v-if="active" class="app-modal__section">
    <header class="app-modal__section-head">
      <h4>Dirección</h4>
      <p>Ubicación principal de la persona de contacto.</p>
    </header>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field full-width">
        <span>Dirección</span>
        <textarea v-model.trim="form.address" class="form-control app-modal-field__textarea" rows="3" placeholder="Dirección"></textarea>
      </label>

      <div class="app-modal-field">
        <span>País</span>
        <multiselect
          v-model="form.country"
          :options="countryOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="128"
          open-direction="below"
          placeholder="Selecciona país"
          class="app-modal-select"
        >
          <template #noResult>
            <span>Sin opción disponible</span>
          </template>
          <template #noOptions>
            <span>Sin opción disponible</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>Estado</span>
        <multiselect
          v-model="form.state"
          :options="stateOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="128"
          open-direction="below"
          placeholder="Selecciona estado"
          class="app-modal-select"
        >
          <template #noResult>
            <span>Sin opción disponible</span>
          </template>
          <template #noOptions>
            <span>Sin opción disponible</span>
          </template>
        </multiselect>
      </div>

      <label class="app-modal-field">
        <span>Ciudad</span>
        <input v-model.trim="form.city" type="text" class="form-control" placeholder="Ciudad" autocomplete="off" />
      </label>

      <label class="app-modal-field">
        <span>Código postal</span>
        <input v-model.trim="form.zipcode" type="text" class="form-control" placeholder="Código postal" autocomplete="off" />
      </label>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PersonSectionAddress',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    countryOptions: {
      type: Array,
      default: () => [],
    },
    stateOptions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
